import { TurnoStatus } from '../../data/types/turnos.type'
import { getColorByTurnoStatus, getTituloTurnoByStatus } from '../calendario/Calendario.page'


export const TurnoEstado = (status: TurnoStatus) => {
	return (
		<span style={{
			backgroundColor: getColorByTurnoStatus(status, 'FONDO'),
			color: getColorByTurnoStatus(status, 'TEXTO'),
			borderRadius: '8px',
			padding: '4px 8px',
			fontSize: '12px',
			fontWeight: 'bold',
		}}>
			{getTituloTurnoByStatus(status)}
		</span>
	)
}